import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route} from '@angular/router';
import {Observable, Subject, of} from 'rxjs';
import { Store, select  } from '@ngrx/store';
import * as fromStore from './store';
import {tap, take, map, switchMap, delay, first, takeUntil} from 'rxjs/operators';
import {urlPath} from './shareModel';
import {PreferenceService} from './services/preference.service';
import { isODM } from '../environments/environment';
import { RegionService } from 'src/app/services/region.service';

@Injectable({
  providedIn: 'root'
})
export class AuthPackageGuard implements CanActivate {
  packageStatus$: Observable<any>;
  private componentDestroyed = new Subject();
  authority = 0;
  defaultHomePage = 0;
  powerMaster = isODM;
  isMsp = false;
  constructor(
    private store: Store<fromStore.State>,
    private router: Router,
    private preferenceService: PreferenceService,
    private regionService: RegionService,
  ) {
     this.packageStatus$ = this.store.select(fromStore.getUserAllModule);
     this.store.select(fromStore.getCurrentUser).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
       this.authority = res.authority;
     });

    // Get isMsp
    this.store.select(fromStore.getIsMsp).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res !== null) {
        this.isMsp = res;
      } else {
        this.isMsp = false;
      }
    });

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url: string = state.url;
    return this.checkPackage(url);
  }

  checkPackage(url) {
    this.defaultHomePage = this.preferenceService.GetDefaultHomePage;
    return this.packageStatus$.pipe(
      first(item => Object.keys(item).length > 0),
      map(module => {
        let activate = true;
        if (url.startsWith('/' + 'index')) { // Default home page setting. 0: Dashboard, 1: GlobalMap
          if (this.defaultHomePage === 1) {
            this.router.navigate(['/globalmap']);
          } else {
            this.router.navigate(['/dashboard']);
          }
        } else if (url.startsWith('/' + 'dashboard')) {
          activate = module['Dashboard']['Value'] === '1';
        } else if (url.startsWith('/' + 'devicemap')) {
          activate = module['Floor Map']['Value'] === '1';
        } else if (url.startsWith('/' + urlPath['Event Logs'])) {
          activate = module['Event Logs']['Value'] === '1';
        } else if (url.startsWith('/' + urlPath['Status Logs'])) {
          activate = module['Status Logs']['Value'] === '1';
        } else if (url.startsWith('/' + urlPath['Energy Use'])) {
          activate = module['Energy Use']['Value'] === '1';
        } else if (url.startsWith('/' + urlPath['Alert Setting'])) {
          activate = module['Alert Setting']['Value'] === '1';
        } else if (url.startsWith('/' + urlPath['GroupDetail'])) {
          activate = module['Group']['Value'] === '1';
        } else if (url.startsWith('/' + urlPath['Global Map'])) {
          activate = module['Global Map']['Value'] === '1';
          if (!activate && this.defaultHomePage === 1) {
            this.defaultHomePage = 0;
            this.preferenceService.SetDefaultHomePage = 0;
          }
        } else if (url.startsWith('/' + urlPath['LicenseSetting'])) {
          activate = module['License Setting']['Value'] === '1';
        } else if (url.startsWith('/license-detail') || url.startsWith('/device-detail')) { // Admin still could enter the page.
          if (this.authority >= 1) {
            activate = true;
          } else {
            activate = module['License Setting']['Value'] === '1';
          }
        } else if (url.startsWith('/' + urlPath['PlanSetting'])) {
          if (this.isMsp) {
            this.router.navigate(['/index']);
          }
        } else if (url.startsWith('/' + urlPath['PurchasePlan'])) {
          if (this.isMsp) {
            this.router.navigate(['/index']);
          }
        } else if (url.startsWith('/' + urlPath['mobilePurchasePlan'])) {
          if (this.isMsp) {
            this.router.navigate(['/index']);
          }
        } else if (url.startsWith('/' + urlPath['PurchaseHistory'])) {
          if (this.isMsp) {
            this.router.navigate(['/index']);
          }
        } else if (url.startsWith('/' + urlPath['LicenseMgtList'])) {
          if (this.isMsp) {
            this.router.navigate(['/index']);
          }
        } else if (url.startsWith('/' + urlPath['HelpMsp'])) {
          if (!this.isMsp) {
            this.router.navigate(['/index']);
          }
        }
        if (!activate) {
          this.router.navigate(['/index']);
        }
        return activate;
      }),
      take(1)
    );
    return of(true);
  }
}
